module.exports = __webpack_public_path__ + "static/media/RUSSELL K. RED 120 SE LOUDSPEAKERS.1fb82c8c.png";